<div class="row" *ngIf="isConfig">
    <div class="col-2" >
        <div class="form-group form-group-sm mb-1">
            <label>Abilita</label>
            <div class="input-group input-group-sm" >
                <select class="form-control form-control-sm" name="enabled" [(ngModel)]="gateway.enabled" >
                    <option [ngValue]="0">No</option>
                    <option [ngValue]="1">Si</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-10" >
        <div class="form-group form-group-sm mb-1" *ngIf="gateway.gateway!='app'">
            <label>Tipologia di contatto</label>
            <div class="input-group input-group-sm" >
                <select class="form-control form-control-sm"  #type_contact [(ngModel)]="gateway.id_type"  title="{{gateway.id_type}}" >
                    <option *ngFor="let t of type_contacts" value="{{t.id}}" >{{t.name}}</option>
                    <option value="0">Contatto specifico</option>
                </select>
                <input *ngIf="gateway.id_type==0" type="text" placeholder="Inserisci email di contatto" class="form-control form-control-sm" [(ngModel)]="email_to" (keyup)="ParseFields()">
            </div>
        </div>
    </div>
</div>
<div class="row" *ngIf="!isConfig">
    <div class="col-2" >
        <div class="form-group form-group-sm mb-1">
            <label>Abilita</label>
            <div class="input-group input-group-sm" >
                <select class="form-control form-control-sm" name="enable" [(ngModel)]="gateway['enable']" >
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Si</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-10" *ngIf="gateway.gateway!='app' && !multipleContact">
        <div class="form-group form-group-sm mb-1">
            <label>Contatto</label>
            <div class="input-group input-group-sm" >
                <select class="form-control form-control-sm" name="contact" [(ngModel)]="gateway['contact']" (change)="onSelectContact($event)">
                    <option *ngFor="let c of gateway['contacts']" [ngValue]="c.value" >{{c.value}} <span *ngIf="c.note!=''">({{c.note}})</span></option>
                    <option value="">Altro...</option>
                </select>
                <input type="text" placeholder="inserisci email / numero di telefono..." class="form-control  form-control-smml-2" name="contact" [(ngModel)]="gateway['contact']" *ngIf="other_contact" />
                <input type="text" placeholder="inserisci il nome del contatto..." class="form-control form-control-sm" name="contact_name" [(ngModel)]="gateway['contact_name']" *ngIf="other_contact" />
            </div>
        </div>
    </div>
</div>
<!-- EMAIL -->
<div class="row" *ngIf="gateway.gateway=='email'">   
    <div class="col-sm-6">
        <div class="form-group form-group-sm mb-1">
            <label>CC</label>
            <input type="email" class="form-control form-control-sm" placeholder="..." name="email_cc" [(ngModel)]="email_cc" (keyup)="ParseFields()">
        </div>
    </div>
     <div class="col-sm-6">
        <div class="form-group form-group-sm mb-1">
            <label>Da</label>
            <input type="email" class="form-control form-control-sm" placeholder="..." name="email_from" [(ngModel)]="email_from" (keyup)="ParseFields()" >
        </div>
    </div>
    <div class="col-sm-12">
        <div class="form-group form-group-sm mb-1">
            <label>Oggetto</label>
            <input type="email" class=" form-control form-control-sm" placeholder="..." [(ngModel)]="email_subject" (keyup)="ParseFields()">
        </div>
    </div>
    <div class="col-sm-12">
        <div class="row">
            <div class="col-md-6">
                <label>HTML</label>
                <textarea class="form-control" rows="16" cols="300" name="email_body" [(ngModel)]="email_body" (keyup)="ParseFields()"></textarea>
            </div>
            <div class="col-md-6">
                <label>Anteprima</label>
                <div style="max-height:25rem; overflow-y:auto" class="border p-1 h-100" [innerHTML]="email_body"></div>
            </div>            
        </div>        
    </div>
    <div class="col-sm-12 mt-2">
        <div class="form-group form-group-sm">
            <label>Allegati</label>
            <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm" placeholder="url del file da allegare" [(ngModel)]="email_attachment" (keyup)="ParseFields()">
                <div class="input-group-append input-group-append-sm">
                    <button type="button" class="btn btn-sm btn-default" (click)="downloadAttach(email_attachment)"><i class="fa fa-eye" title="Visualizza"></i></button>
                </div>    
            </div>
            <!-- <small>
                usare le keywords per specificare un collegamento dinamico. <br/>
                ex template[18,id] 18 = id template di esportazione
            </small> -->
        </div>
    </div>
     <!--<ckeditor [editor]="Editor" [(ngModel)]="email_body" (keyup)="ParseFields()"></ckeditor>-->
</div>
<!-- SMS -->
<div class="row" *ngIf="gateway.gateway=='sms'">
    <div class="col-sm-12">
        <div class="form-group form-group-sm mb-1">
            <label>Messaggio</label>
            <textarea rows="10" cols="300" class="form-control form-control-sm" placeholder="..." name="sms_body" [(ngModel)]="sms_body" (keyup)="ParseFields()" ></textarea>
        </div>
    </div>
</div>
<!-- WhatsApp-->
<div class="row" *ngIf="gateway.gateway=='whatsapp'">
    <div class="col-sm-12">
        <div class="form-group  form-group-sm mb-1">
            <label>Messaggio</label>
            <textarea rows="10" cols="300" class="form-control form-control-sm" placeholder="..." name="whatsapp_body" [(ngModel)]="whatsapp_body" (keyup)="ParseFields()" ></textarea>
        </div>
    </div>
</div>
<!-- Push App-->
<div class="row" *ngIf="gateway.gateway=='app'">
    <div class="col-sm-12">
        <div class="form-group  form-group-sm mb-1">
            <label>Messaggio</label>
            <textarea rows="20" cols="300" class="form-control form-control-sm" placeholder="..." name="app_body" [(ngModel)]="app_body" (keyup)="ParseFields()" ></textarea>
        </div>
    </div>
</div>